import { render, staticRenderFns } from "./EditDefect.vue?vue&type=template&id=4b658180&scoped=true&"
import script from "./EditDefect.vue?vue&type=script&lang=js&"
export * from "./EditDefect.vue?vue&type=script&lang=js&"
import style0 from "./EditDefect.vue?vue&type=style&index=0&id=4b658180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b658180",
  null
  
)

export default component.exports